// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--10-1!../../node_modules/less-loader/dist/cjs.js!../../node_modules/sass-resources-loader/lib/loader.js??ref--10-3!./global-component.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("4940ae14", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/css/global-component.less
// module id = P1xC
// module chunks = 216